import { Skeleton } from 'antd';
import { useQualityMetricsContext } from '../../quality-metrics-context';
import { MetricSidebarItem } from './metric-sidebar-item';
import { ListItemsNavigator } from 'src/components/common/items-navigator';
import styles from './metrics-sidebar.module.scss';

// Number of skeleton rows to show on the very first paint, before /user has resolved.
const INITIAL_SKELETON_COUNT = 3;

function SidebarSkeleton({ count }) {
  return (
    <div className={styles.list}>
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className={styles.skeletonItem}>
          <Skeleton active title={{ width: '60%' }} paragraph={{ rows: 1, width: '80%' }} />
        </div>
      ))}
    </div>
  );
}

export function MetricsSidebar() {
  const { metrics, selectedMetricId, setSelectedMetricId, userTrendsMap, loading, lang } =
    useQualityMetricsContext();

  return (
    <nav className={styles.sidebar} aria-label={lang.METRICS_HEADER}>
      {loading ? (
        <SidebarSkeleton count={metrics.length || INITIAL_SKELETON_COUNT} />
      ) : (
        <ListItemsNavigator className={styles.list}>
          {metrics.map(metric => (
            <MetricSidebarItem
              key={metric.metricId}
              metric={metric}
              isSelected={metric.metricId === selectedMetricId}
              trend={userTrendsMap[metric.metricId]}
              onSelect={() => setSelectedMetricId(metric.metricId)}
            />
          ))}
        </ListItemsNavigator>
      )}
    </nav>
  );
}
